import settingLocal from './settings/setting-local'
import settingDev from './settings/setting-dev'
import settingInt from './settings/setting-int'
import settingTest from './settings/setting-test'
import settingLocalMock from './settings/setting-local-mock'
import settingBusinesspro from './settings/setting-businesspro'
import settingQaBusinesspro from './settings/setting-qa_businesspro'
import settingPreBuisnesspro from './settings/setting-pre_businesspro'
import settingTestBusinesspro from './settings/setting-test-businesspro'
import settingDemoitgroup from './settings/setting-demoitgroup'

let setting
if (process.argv.includes('--test') || process.argv.includes('--mocks')) {
  setting = settingTest
} else if ((process.argv.includes('--localMock'))) {
  setting = settingLocalMock
} else if ((process.argv.includes('--local'))) {
  setting = settingLocal
} else if (process.argv.includes('--dev')) {
  setting = settingDev
} else if (process.argv.includes('--int')) {
  setting = settingInt
} else if (process.argv.includes('--businesspro')) {
  setting = settingBusinesspro
} else if (process.argv.includes('--qa_businesspro')) {
  setting = settingQaBusinesspro
} else if (process.argv.includes('--pre_businesspro')) {
  setting = settingPreBuisnesspro
} else if (process.argv.includes('--test-businesspro')) {
  setting = settingTestBusinesspro
} else if (process.argv.includes('--demoitgroup')) {
  setting = settingDemoitgroup
}

export default setting
